import { apiGetCategoryList, RespCategory } from '@vas2t-lowcode/api';
import type { AxiosPromise } from 'axios';

let templateTypeReq = undefined as undefined | AxiosPromise<RespCategory[]>;

/**
 * 获取预加载的数据
 *
 * @returns
 */
export const reqTemplateTypeDataAsync = () => {
  if (!templateTypeReq) {
    templateTypeReq = window._reqCategoryListAsync || apiGetCategoryList();
    return templateTypeReq;
  }

  return templateTypeReq;
};

/**
 * 重置预加载的数据, 防止下次reqBannerTopDataAsync获取的为旧数据
 *
 * @returns
 */
export const resetTemplateTypeDataAsync = () => {
  templateTypeReq = undefined;
  window._reqCategoryListAsync = undefined;
};
